import JoyuCustomerService, {
  Channel,
  Env,
  GameCode,
  type InitConfig,
  Lang,
} from '@joyu/customer-service'
import { getStorage } from '@/utils/cookie'

const transformToLang = (lang: string) => {
  return {
    'zh-CN': Lang.ZhCn,
    'zh-TW': Lang.ZhTw,
    id: Lang.In,
  }[lang]
}

export const getLang = () => {
  const lang = localStorage.getItem('i18nextLng')
  return (lang ? transformToLang(lang) || lang : Lang.En) as Lang
}

export const customerServiceConfig: InitConfig = {
  env: import.meta.env.VITE_APP_ENV === 'ready' ? Env.Test : Env.Formal,
  gameCode: GameCode.RO,
  region: import.meta.env.VITE_APP_MODE,
  channel: Channel.OfficialWeb,
  language: getLang(),
  debug: import.meta.env.VITE_APP_ENV === 'ready',
}

export default class Kefu {
  public static init = () => {
    const cs = JoyuCustomerService.getInstance(customerServiceConfig)
    window.cs = cs
  }

  public static open = () => {
    window.cs.open({
      open_id: getStorage('account_info')?.open_id,
      app_info: {
        name: `${GameCode.RO}-${import.meta.env.VITE_APP_MODE}`,
        version: '0.0.1',
        language: getLang(),
      },
      role_info: {
        role_id: getStorage('account_info')?.role_id,
        server_id: getStorage('account_info')?.server_id,
        server_name: getStorage('account_info')?.server_name,
        role_name: getStorage('account_info')?.name,
      },
    })
  }
}
